import { UserType } from "app/types/userType";
import { BetslipPanelTypes } from "app/utils/const";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { $Values } from "utility-types";
import SegmentedControl from "../../../../../../components/SegmentedControl/SegmentedControl";
import FinanceSummary from "../../../../../../partials/FinanceSummary/FinanceSummary";
import "../../BetDrawerScreen.scss";
import BetSlipTypesHeader from "../BetSlipTypesHeader/BetSlipTypesHeader";
import "./BetDrawerHeaderDesktop.scss";
type Props = {
  toggleBetslipOpenBets: (...args: Array<any>) => any;
  betSlipCount: number;
  betslipPanelTypes: $Values<typeof BetslipPanelTypes>;
  currentBetsCount: number;
  currentOpenPositionsCount: number;
  setFlashFlag: (...args: Array<any>) => any;
  isOrangeFlashActive: boolean;
  setBetSlipTypeTab: Function;
  betSlipTypeTab: string;
  user: UserType;
};
type State = {
  tab: string;
};

class BetDrawerHeaderDesktop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // will need to move to parent component
    this.state = {
      tab: this.props.betslipPanelTypes,
    };
  }

  setTab = (tabType: string) => {
    if (this.state.tab === tabType) {
      return null;
    }

    this.setState({
      tab: tabType,
    });

    if (this.props.toggleBetslipOpenBets) {
      this.props.toggleBetslipOpenBets(tabType);
    }
  };

  resetAnimation() {
    this.props.setFlashFlag();
  }

  getTabs = () => {
    return [
      {
        title: (
          <span>
            <FormattedMessage tagName="span" id="bets-slip" /> (
            {this.props.betSlipCount})
          </span>
        ),
        callback: () => this.setTab(BetslipPanelTypes.BETSLIP),
        isActive: this.state.tab === BetslipPanelTypes.BETSLIP,
        googleTagClickId: "BETSLIP",
        dlvEventName: "BETSLIP",
      },
      {
        //translate titles
        title: (
          <span>
            <FormattedMessage tagName="span" id="bets-slip-open-bets" /> (
            {this.props.currentBetsCount})
          </span>
        ),
        callback: () => this.setTab(BetslipPanelTypes.OPENBETS),
        isActive: this.state.tab === BetslipPanelTypes.OPENBETS,
        googleTagClickId: "OPENBETS",
        dlvEventName: "OPENBETS",
      },
      {
        //translate titles
        title: (
          <span>
            <FormattedMessage tagName="span" id="bets-slip-open-positions" /> (
            {this.props.currentOpenPositionsCount})
          </span>
        ),
        callback: () => this.setTab(BetslipPanelTypes.OPENPOSITIONS),
        isActive: this.state.tab === BetslipPanelTypes.OPENPOSITIONS,
        googleTagClickId: "OPENPOSITIONS",
        dlvEventName: "OPENPOSITIONS",
      },
    ];
  };

  // TEMP LAYOUT - BET-2476
  render() {
    return (
      <div>
        <FinanceSummary />
        <div className="toggle-bets__buttons">
          <SegmentedControl
            tabs={this.getTabs()}
            tabTypes={BetslipPanelTypes}
          />
        </div>
        {this.props.user["multiplierFeatureEnabled"] &&
          this.props.user.multipleBetAllowed &&
          this.state.tab === BetslipPanelTypes.BETSLIP && (
            <BetSlipTypesHeader
              setTab={this.props.setBetSlipTypeTab}
              tab={this.props.betSlipTypeTab}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isOrangeFlashActive: state.betSlipListModel.isOrangeFlashActive,
  user: state.userModel.user,
});

const mapDispatchToProps = dispatch => ({
  setFlashFlag: () => dispatch.betSlipListModel.setFlashFlag(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetDrawerHeaderDesktop) as any;
